import { useEffect, useMemo, useState } from 'react';

import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import OptionList, { IOptionVariant } from '@r1-frontend/ui-react/components/OptionList';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { EPriceOperationTypes } from '~/src/entities/price';
import { useContextSelector } from '~/src/features/work-in-home-ab/components/Description/components/Credit/context/hooks';

import { getCreditOptions } from './helpers';

import { PopupCustomStyles } from './styled';

interface IProps {
    onConfirmSelect: (params: { payOption: { optionId: string, variantId: string | number } }) => void,
    creditConditions: ICreditCondition[],
    onClose: () => void,
}
export const SelectCreditOptionPopup = ({ onClose, creditConditions, onConfirmSelect }: IProps): JSX.Element | null => {
    const [selectedOption, setSelectedOption] = useState<IOptionVariant>();
    const [selectedPayOptionId, setSelectedPayOptionId] = useState<string | number>('');

    const { isShow, selectedCreditCondition } = useContextSelector(state => ({
        isShow: state.isShowOptionSelect,
        selectedCreditCondition: state.selectedCreditCondition,
    }));

    const creditOptions = useMemo(() => getCreditOptions(creditConditions), [creditConditions]);

    useEffect(() => {
        if (selectedCreditCondition) {
            setSelectedPayOptionId(selectedCreditCondition.duration);
            const currentCreditCondition = creditOptions.find(item => item.id === selectedCreditCondition.duration);
            setSelectedOption(currentCreditCondition);
        }
    }, [creditOptions, selectedCreditCondition]);

    const onConfirmSelectHandler = () => {
        if (selectedOption) {
            onConfirmSelect({
                payOption: {
                    optionId: EPriceOperationTypes.Credit,
                    variantId: selectedPayOptionId,
                },
            });
        }
    };

    const selectOptionHandler = (optionId: string | number) => {
        setSelectedPayOptionId(optionId);

        const currentCreditCondition = creditOptions.find(item => item.id === optionId);
        setSelectedOption(currentCreditCondition);
    };
    return (
        <DefaultPopup
            isOpen={isShow}
            justify={'center'}
            align={'center'}
            color={COLORS.BgSurface}
            customStyles={PopupCustomStyles}
            onClose={onClose}
        >
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <FullWidthListContainer $direction={'column'} $wrap={'nowrap'} $size={24}>
                    <H3 $withIndent={false}>Условия рассрочки</H3>
                    <ListContainer $direction={'column'} $wrap={'nowrap'} $size={16}>
                        <OptionList
                            options={creditOptions}
                            selectedOptionId={selectedPayOptionId}
                            selectedVariantId={''}
                            onClickOption={selectOptionHandler}
                        />
                    </ListContainer>
                    <ButtonGroup>
                        <Button size={'large'} bType={'action'} onClick={onConfirmSelectHandler}>Сохранить</Button>
                    </ButtonGroup>
                </FullWidthListContainer>
            </IndentContainer>
        </DefaultPopup>
    );
};
